import { ONBOARDING_HERO_POSTER } from './constants';

/**
 * The /welcome route's load state: the hero poster as a CSS background over the
 * mb-teal-deep base fill (onboarding-design.md §3). The base colour shows for an
 * instant before the poster decodes, and acts as a matte if it 404s.
 *
 * Shared by two callers deliberately — the route-scoped Suspense fallback in
 * router.tsx, and Onboarding.tsx's auth-loading hold for an un-completed visitor
 * (onboarding-design.md §3). Both must look identical: a
 * guest goes poster -> hero against the same poster, so the transition reads as
 * continuous rather than as a flash.
 */
export function OnboardingPosterFallback() {
  return (
    <div
      className="h-dvh w-full bg-mb-teal-deep bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${ONBOARDING_HERO_POSTER})` }}
    />
  );
}
